/* Rescuevation – Wasser-Tuch-Produktseite (rescu-ww-*), 02.10.2026.

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Dieses Script
   legt nur einmalige Keyframe-Läufe darüber (Klasse rww-go, nach animationend
   wieder entfernt) und startet Schleifen nur, solange sie zu sehen sind.

   Außerdem: Set-Baukasten und Kombi-Feld in der Kaufbox legen mehrere Artikel
   in einem Aufruf in den Warenkorb (/cart/add.js mit items) und öffnen danach
   Dawns Warenkorb-Schublade. */
(function () {
  'use strict';
  if (window.__rww) return;
  window.__rww = true;

  var doc = document.documentElement;
  doc.classList.add('rww-js');

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var vh = function () { return window.innerHeight || doc.clientHeight; };

  /* ---------- Geld ---------- */

  var zahlFormat = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function euro(cent) { return zahlFormat.format(cent / 100) + ' €'; }
  function brutto(cent) { return Math.round(cent * 1.19); }

  /* ---------- Einblenden beim Scrollen ---------- */

  function einmal(el) {
    if (el.__rwwLief) return;
    el.__rwwLief = true;
    el.classList.add('rww-go');
    var ende = function (e) {
      if (e && e.target !== el) return;
      el.classList.remove('rww-go');
      el.removeEventListener('animationend', ende);
    };
    el.addEventListener('animationend', ende);
    setTimeout(ende, 4000);
  }

  function staffeln(liste) {
    var gruppen = new Map();
    liste.forEach(function (el) {
      var g = el.closest('[data-ww-gruppe]') || el.parentElement;
      var n = gruppen.get(g) || 0;
      if (!el.style.getPropertyValue('--rww-d')) {
        var d = el.hasAttribute('data-ww-d') ? parseInt(el.getAttribute('data-ww-d'), 10) : n * 110;
        el.style.setProperty('--rww-d', d + 'ms');
      }
      gruppen.set(g, n + 1);
    });
  }

  function einblenden(wurzel) {
    if (ruhig || !hatIO) return;
    var els = Array.prototype.slice.call(wurzel.querySelectorAll('[data-ww-in]'));
    if (!els.length) return;
    staffeln(els);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target);
      });
    }, { rootMargin: '0px 0px 60px 0px', threshold: 0 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      /* Was beim Laden schon im Bild steht, bleibt ruhig – außer es ist ausdrücklich
         für den Seitenstart gedacht (Bühne). */
      if (el.hasAttribute('data-ww-sofort')) { einmal(el); return; }
      if (r.top < vh() - 40 && r.bottom > 0) return;
      io.observe(el);
    });
  }

  /* ---------- Schleifen nur, solange sichtbar ---------- */

  function schleifen(wurzel) {
    if (ruhig || !hatIO) return;
    var els = wurzel.querySelectorAll('[data-ww-spiel]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('rww-spielt', e.isIntersecting); });
    }, { threshold: 0.2 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ---------- Kennzahlen zählen einmal hoch ---------- */

  function zaehlen(wurzel) {
    if (ruhig || !hatIO) return;
    var els = wurzel.querySelectorAll('[data-ww-zahl]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var ziel = parseFloat(String(el.getAttribute('data-ww-zahl')).replace(/[^0-9.,]/g, '').replace(',', '.'));
        if (isNaN(ziel)) return;
        var endText = el.textContent;
        var t0 = null;
        var schritt = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 1400);
          var w = 1 - Math.pow(1 - p, 4);
          el.textContent = endText.replace(/[0-9]+/, String(Math.round(ziel * w)));
          if (p < 1) requestAnimationFrame(schritt); else el.textContent = endText;
        };
        requestAnimationFrame(schritt);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh() && r.bottom > 0) return;
      io.observe(el);
    });
  }

  /* ---------- Bühne: Tiefe per Maus und Scroll ---------- */

  function buehne(wurzel) {
    if (ruhig) return;
    var szenen = wurzel.querySelectorAll('[data-ww-szene]');
    Array.prototype.forEach.call(szenen, function (szene) {
      var sichtbar = true;
      if (hatIO) {
        new IntersectionObserver(function (e) { sichtbar = e[0].isIntersecting; }).observe(szene);
      }
      var fein = window.matchMedia('(pointer: fine)').matches;
      if (fein) {
        var ziel = { x: 0, y: 0 }, ist = { x: 0, y: 0 }, laeuft = false;
        var takt = function () {
          ist.x += (ziel.x - ist.x) * 0.08;
          ist.y += (ziel.y - ist.y) * 0.08;
          szene.style.setProperty('--mx', ist.x.toFixed(3));
          szene.style.setProperty('--my', ist.y.toFixed(3));
          if (Math.abs(ziel.x - ist.x) > 0.002 || Math.abs(ziel.y - ist.y) > 0.002) requestAnimationFrame(takt);
          else laeuft = false;
        };
        var bereich = szene.closest('.rww') || szene;
        bereich.addEventListener('pointermove', function (e) {
          if (!sichtbar) return;
          var r = bereich.getBoundingClientRect();
          ziel.x = ((e.clientX - r.left) / r.width - 0.5) * 2;
          ziel.y = ((e.clientY - r.top) / r.height - 0.5) * 2;
          if (!laeuft) { laeuft = true; requestAnimationFrame(takt); }
        });
        bereich.addEventListener('pointerleave', function () {
          ziel.x = 0; ziel.y = 0;
          if (!laeuft) { laeuft = true; requestAnimationFrame(takt); }
        });
      }
      var geplant = false;
      var scrollen = function () {
        geplant = false;
        if (!sichtbar) return;
        var r = szene.getBoundingClientRect();
        var p = (r.top + r.height / 2 - vh() / 2) / vh();
        szene.style.setProperty('--sy', Math.max(-1, Math.min(1, p)).toFixed(3));
      };
      window.addEventListener('scroll', function () {
        if (!geplant) { geplant = true; requestAnimationFrame(scrollen); }
      }, { passive: true });
      scrollen();
    });
  }

  /* ---------- Wisch-Fläche: Ruß weg, per Scroll und per Hand ---------- */

  function zufall(seed) {
    var s = seed;
    return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
  }

  function wischflaeche(el) {
    var canvas = el.querySelector('canvas');
    var tuch = el.querySelector('.rww-wisch__tuch');
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var w = 0, h = 0, dpr = 1;
    var fortschritt = 0;      /* 0..1, aus dem Scroll */
    var gezeichnet = 0;       /* bis wohin der Scroll-Pfad schon gewischt hat */
    var fertig = false;
    var handArbeit = 0;

    /* Wischpfad: drei Bahnen im Zickzack, wie ein Tuch über die Haut gezogen wird */
    function pfadPunkt(p) {
      var bahnen = 3;
      var b = Math.min(bahnen - 1, Math.floor(p * bahnen));
      var q = p * bahnen - b;
      var vonLinks = b % 2 === 0;
      var x = vonLinks ? -0.1 + q * 1.2 : 1.1 - q * 1.2;
      var y = 0.2 + b * 0.3 + Math.sin(q * Math.PI) * 0.05;
      return { x: x, y: y };
    }

    function russMalen() {
      var r = el.getBoundingClientRect();
      dpr = Math.min(2, window.devicePixelRatio || 1);
      w = Math.max(1, Math.round(r.width));
      h = Math.max(1, Math.round(r.height));
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, w, h);
      var rnd = zufall(4711);
      ctx.fillStyle = '#121212';
      ctx.globalAlpha = 0.93;
      ctx.fillRect(0, 0, w, h);
      ctx.globalAlpha = 1;
      /* Schlieren und Flecken */
      for (var i = 0; i < 70; i++) {
        var x = rnd() * w, y = rnd() * h, rad = 30 + rnd() * Math.max(w, h) * 0.22;
        var g = ctx.createRadialGradient(x, y, 0, x, y, rad);
        var hell = rnd() > 0.55;
        g.addColorStop(0, hell ? 'rgba(78,70,62,0.38)' : 'rgba(6,6,6,0.5)');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g;
        ctx.fillRect(x - rad, y - rad, rad * 2, rad * 2);
      }
      /* Körnung */
      for (var k = 0; k < (w * h) / 55; k++) {
        ctx.fillStyle = rnd() > 0.5 ? 'rgba(0,0,0,0.35)' : 'rgba(120,110,100,0.18)';
        var s = rnd() * 2.2;
        ctx.fillRect(rnd() * w, rnd() * h, s, s);
      }
      gezeichnet = 0;
      ctx.globalCompositeOperation = 'destination-out';
    }

    function wischen(x, y, groesse) {
      var g = ctx.createRadialGradient(x, y, groesse * 0.35, x, y, groesse);
      g.addColorStop(0, 'rgba(0,0,0,1)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(x, y, groesse, 0, Math.PI * 2);
      ctx.fill();
    }

    function tuchSetzen(p, sichtbar) {
      if (!tuch) return;
      var pt = pfadPunkt(Math.min(1, p));
      var tw = tuch.offsetWidth, th = tuch.offsetHeight;
      var dreh = -8 + Math.sin(p * Math.PI * 6) * 5;
      tuch.style.transform = 'translate(' + (pt.x * w - tw / 2).toFixed(1) + 'px,' + (pt.y * h - th / 2).toFixed(1) + 'px) rotate(' + dreh.toFixed(1) + 'deg)';
      tuch.style.opacity = sichtbar ? '1' : '0';
    }

    function bisFortschritt(p) {
      var groesse = Math.max(w, h) * 0.17;
      var stufe = 0.004;
      while (gezeichnet < p) {
        gezeichnet = Math.min(p, gezeichnet + stufe);
        var pt = pfadPunkt(gezeichnet);
        wischen(pt.x * w, pt.y * h, groesse);
      }
    }

    function abschliessen() {
      if (fertig) return;
      fertig = true;
      var start = null;
      var ausblenden = function (t) {
        if (!start) start = t;
        var p = Math.min(1, (t - start) / 600);
        canvas.style.opacity = String(1 - p);
        if (p < 1) requestAnimationFrame(ausblenden);
      };
      requestAnimationFrame(ausblenden);
      if (tuch) tuch.style.opacity = '0';
      el.classList.add('rww-wisch--fertig');
    }

    function scrollTakt() {
      if (fertig) return;
      var r = el.getBoundingClientRect();
      /* Start, wenn die Fläche zu 60 % im Bild ist; fertig, wenn ihre Mitte das obere Drittel erreicht */
      var start = vh() - r.height * 0.6;
      var ende = vh() * 0.3 - r.height * 0.5;
      var p = (start - r.top) / (start - ende);
      p = Math.max(0, Math.min(1, p));
      if (p > fortschritt) {
        fortschritt = p;
        bisFortschritt(p);
      }
      tuchSetzen(fortschritt, fortschritt > 0.01 && fortschritt < 0.98);
      if (fortschritt >= 0.98) abschliessen();
    }

    /* Hand: Maus oder Finger wischt mit */
    var letzter = null;
    el.addEventListener('pointerdown', function (e) { letzter = { x: e.offsetX, y: e.offsetY }; });
    el.addEventListener('pointermove', function (e) {
      if (fertig) return;
      if (e.pointerType === 'mouse' && e.buttons === 0 && letzter === null) {
        /* Maus wischt auch ohne Klick, sobald sie über der Fläche ist */
        letzter = { x: e.offsetX, y: e.offsetY };
      }
      if (!letzter) return;
      var groesse = Math.max(w, h) * 0.11;
      var dx = e.offsetX - letzter.x, dy = e.offsetY - letzter.y;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var n = Math.max(1, Math.ceil(dist / 8));
      for (var i = 1; i <= n; i++) wischen(letzter.x + dx * i / n, letzter.y + dy * i / n, groesse);
      letzter = { x: e.offsetX, y: e.offsetY };
      handArbeit += dist;
      if (handArbeit > (w + h) * 4.5) abschliessen();
    });
    var loslassen = function () { letzter = null; };
    el.addEventListener('pointerup', loslassen);
    el.addEventListener('pointerleave', loslassen);
    el.addEventListener('pointercancel', loslassen);

    russMalen();
    el.classList.add('rww-wisch--aktiv');
    var geplant = false;
    window.addEventListener('scroll', function () {
      if (!geplant) { geplant = true; requestAnimationFrame(function () { geplant = false; scrollTakt(); }); }
    }, { passive: true });
    var breite = w;
    window.addEventListener('resize', function () {
      if (fertig) return;
      var neu = Math.round(el.getBoundingClientRect().width);
      if (Math.abs(neu - breite) < 40) return;
      breite = neu;
      russMalen();
      bisFortschritt(fortschritt);
    });
    scrollTakt();
  }

  function wischen(wurzel) {
    if (ruhig) return;
    var els = wurzel.querySelectorAll('[data-ww-wisch]');
    Array.prototype.forEach.call(els, function (el) {
      /* Liegt die Fläche beim Laden schon komplett über der Mitte, bleibt sie sauber */
      var r = el.getBoundingClientRect();
      if (r.bottom < vh() * 0.35) return;
      wischflaeche(el);
    });
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) throw new Error(daten.description || daten.message || 'HTTP ' + res.status);
        return daten;
      });
    }).then(function (daten) {
      if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
        schublade.classList.remove('is-empty');
        schublade.renderContents(daten);
      } else {
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  function knopfLaeuft(btn, an) {
    if (an) {
      btn.__rwwLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Wird hinzugefügt …';
    } else {
      btn.disabled = false;
      if (btn.__rwwLabel) btn.innerHTML = btn.__rwwLabel;
    }
  }

  /* ---------- Set-Baukasten ---------- */

  function setBaukasten(wurzel) {
    var bereiche = wurzel.querySelectorAll('[data-ww-kombi]');
    Array.prototype.forEach.call(bereiche, function (bereich) {
      var planer = bereich.querySelector('[data-ww-planer]');
      var faktor = 1;
      var karten = Array.prototype.slice.call(bereich.querySelectorAll('[data-ww-set]'));

      function rechnen(karte, ticken) {
        var summe = 0, stueck = 0;
        karte.querySelectorAll('[data-ww-posten]').forEach(function (p, i) {
          var menge = parseInt(p.getAttribute('data-menge'), 10) || 0;
          var preis = parseInt(p.getAttribute('data-preis'), 10) || 0;
          var out = p.querySelector('output');
          if (out) out.textContent = String(menge * faktor);
          var feld = karte.querySelector('[data-ww-feld="' + i + '"]');
          if (feld) feld.value = String(menge * faktor);
          var minus = p.querySelector('[data-ww-minus]');
          if (minus) minus.disabled = menge <= 0;
          summe += menge * preis * faktor;
          stueck += menge;
        });
        var netto = karte.querySelector('[data-ww-netto]');
        var bru = karte.querySelector('[data-ww-brutto]');
        if (netto) {
          netto.textContent = euro(summe);
          if (ticken && !ruhig) { netto.classList.remove('rww-tick'); void netto.offsetWidth; netto.classList.add('rww-tick'); }
        }
        if (bru) bru.textContent = euro(brutto(summe));
        var btn = karte.querySelector('[data-ww-set-kauf]');
        if (btn) btn.disabled = stueck === 0;
      }

      karten.forEach(function (karte) {
        karte.addEventListener('click', function (e) {
          var plus = e.target.closest('[data-ww-plus-eins]');
          var minus = e.target.closest('[data-ww-minus]');
          if (plus || minus) {
            var p = (plus || minus).closest('[data-ww-posten]');
            var m = parseInt(p.getAttribute('data-menge'), 10) || 0;
            m = plus ? Math.min(99, m + 1) : Math.max(0, m - 1);
            p.setAttribute('data-menge', String(m));
            rechnen(karte, true);
            return;
          }
          var kauf = e.target.closest('[data-ww-set-kauf]');
          if (!kauf) return;
          e.preventDefault();
          var items = [];
          karte.querySelectorAll('[data-ww-posten]').forEach(function (p) {
            var menge = (parseInt(p.getAttribute('data-menge'), 10) || 0) * faktor;
            if (menge > 0) items.push({ id: parseInt(p.getAttribute('data-variante'), 10), quantity: menge });
          });
          if (!items.length) return;
          var status = karte.querySelector('[data-ww-status]');
          if (status) { status.textContent = ''; status.classList.remove('rww-set__status--fehler'); }
          knopfLaeuft(kauf, true);
          inDenWarenkorb(items).then(function () {
            knopfLaeuft(kauf, false);
            if (status) status.textContent = 'Im Warenkorb. Du kannst die Mengen dort noch ändern.';
          }).catch(function (err) {
            knopfLaeuft(kauf, false);
            if (status) {
              status.classList.add('rww-set__status--fehler');
              status.textContent = 'Das hat nicht geklappt' + (err && err.message ? ': ' + err.message : '') + '. Versuch es noch einmal oder fordere ein Angebot an.';
            }
          });
        });
        rechnen(karte, false);
      });

      if (planer) {
        var feld = planer.querySelector('output');
        planer.addEventListener('click', function (e) {
          var plus = e.target.closest('[data-ww-plus-eins]');
          var minus = e.target.closest('[data-ww-minus]');
          if (!plus && !minus) return;
          faktor = plus ? Math.min(50, faktor + 1) : Math.max(1, faktor - 1);
          if (feld) feld.textContent = String(faktor);
          var m = planer.querySelector('[data-ww-minus]');
          if (m) m.disabled = faktor <= 1;
          karten.forEach(function (k) { rechnen(k, true); });
        });
      }
    });

    /* Sprung aus den Einsatzlagen: passendes Set hervorheben */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-ww-set-ziel]');
      if (!link) return;
      var ziel = document.querySelector('[data-ww-set="' + link.getAttribute('data-ww-set-ziel') + '"]');
      if (!ziel) return;
      e.preventDefault();
      ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' });
      ziel.classList.remove('rww-set--fokus');
      void ziel.offsetWidth;
      ziel.classList.add('rww-set--fokus');
      setTimeout(function () { ziel.classList.remove('rww-set--fokus'); }, 2600);
    });
  }

  /* ---------- Set-Wahl in der Bühne (Mehrfachauswahl) ---------- */

  function buehnenWahl(wurzel) {
    var bereiche = wurzel.querySelectorAll('[data-ww-wahl]');
    Array.prototype.forEach.call(bereiche, function (bereich) {
      var sektion = bereich.closest('.rww-buehne') || bereich;
      var kacheln = Array.prototype.slice.call(bereich.querySelectorAll('[data-ww-wahl-opt]'));
      var tuchPreis = parseInt(bereich.getAttribute('data-tuch-preis'), 10) || 0;
      var tuchId = parseInt(bereich.getAttribute('data-tuch-variante'), 10);
      var netto = bereich.querySelector('[data-ww-netto]');
      var bru = bereich.querySelector('[data-ww-brutto]');
      var label = bereich.querySelector('[data-ww-label]');
      var felder = bereich.querySelector('[data-ww-felder]');
      var kauf = bereich.querySelector('[data-ww-wahl-kauf]');
      var status = bereich.querySelector('[data-ww-status]');
      var bilder = Array.prototype.slice.call(sektion.querySelectorAll('[data-ww-wahl-bild]'));

      function gewaehlte() {
        return kacheln.filter(function (k) { return k.getAttribute('aria-checked') === 'true'; });
      }

      /* Posten zusammenfassen: gleiche Variante nur einmal, Tücher aller Sets addiert */
      function posten() {
        var sum = {}, reihe = [], tuch = 0, cent = 0;
        gewaehlte().forEach(function (k) {
          var id = k.getAttribute('data-pv');
          var pm = parseInt(k.getAttribute('data-pm'), 10) || 0;
          var tm = parseInt(k.getAttribute('data-tm'), 10) || 0;
          cent += (parseInt(k.getAttribute('data-pp'), 10) || 0) * pm + tuchPreis * tm;
          if (!(id in sum)) { sum[id] = 0; reihe.push(id); }
          sum[id] += pm;
          tuch += tm;
        });
        var items = reihe.map(function (id) { return { id: parseInt(id, 10), quantity: sum[id] }; });
        if (tuch > 0) items.push({ id: tuchId, quantity: tuch });
        return { items: items, cent: cent };
      }

      function aktualisieren(still) {
        var sel = gewaehlte();
        var p = posten();
        var mehr = sel.length > 1;
        if (netto) {
          netto.textContent = euro(p.cent);
          if (!still && !ruhig) { netto.classList.remove('rww-tick'); void netto.offsetWidth; netto.classList.add('rww-tick'); }
        }
        if (bru) bru.textContent = euro(brutto(p.cent));
        if (label) label.textContent = sel.length === 0 ? 'Wähl mindestens ein Set' : label.getAttribute(mehr ? 'data-mehr' : 'data-eins');
        var knopfText = kauf && kauf.querySelector('[data-ww-knopftext]');
        if (knopfText) knopfText.textContent = kauf.getAttribute(mehr ? 'data-mehr' : 'data-eins');
        if (kauf) kauf.disabled = sel.length === 0;
        if (felder) {
          felder.innerHTML = '';
          p.items.forEach(function (it) {
            ['id', 'quantity'].forEach(function (f) {
              var inp = document.createElement('input');
              inp.type = 'hidden';
              inp.name = 'items[][' + f + ']';
              inp.value = String(it[f]);
              felder.appendChild(inp);
            });
          });
        }
        /* Bilder: alle gewählten Gebinde nebeneinander, das zuletzt gewählte fliegt ein */
        var keys = sel.map(function (k) { return k.getAttribute('data-ww-wahl-opt'); });
        bilder.forEach(function (b) {
          var i = keys.indexOf(b.getAttribute('data-ww-wahl-bild'));
          var an = i > -1;
          if (an && !b.classList.contains('is-aktiv') && !still && !ruhig) {
            b.classList.remove('rww-rein'); void b.offsetWidth; b.classList.add('rww-rein');
          }
          b.classList.toggle('is-aktiv', an);
          b.style.setProperty('--pos', an ? String(keys.length - 1 - i) : '0');
        });
        if (status) status.textContent = '';
        var namen = sel.map(function (k) { var o = k.querySelector('.rww-wahl__ort'); return o ? o.textContent.trim() : ''; });
        document.dispatchEvent(new CustomEvent('rww:wahl', { detail: { namen: namen, cent: p.cent } }));
      }

      kacheln.forEach(function (k) {
        k.addEventListener('click', function () {
          k.setAttribute('aria-checked', k.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
          aktualisieren(false);
        });
      });

      if (kauf) {
        kauf.addEventListener('click', function (e) {
          e.preventDefault();
          var p = posten();
          if (!p.items.length) return;
          knopfLaeuft(kauf, true);
          inDenWarenkorb(p.items).then(function () {
            knopfLaeuft(kauf, false);
            if (status) status.textContent = 'Im Warenkorb. Ein Paket, einmal Versand.';
          }).catch(function (err) {
            knopfLaeuft(kauf, false);
            if (status) status.textContent = 'Das hat nicht geklappt' + (err && err.message ? ': ' + err.message : '') + '.';
          });
        });
      }
      aktualisieren(true);
    });
  }

  /* ---------- Set-Leiste unten ---------- */

  function setLeiste() {
    var bar = document.querySelector('[data-ww-sticky]');
    if (!bar) return;
    var titel = bar.querySelector('[data-ww-sticky-titel]');
    var preis = bar.querySelector('[data-ww-sticky-preis]');
    var knopf = bar.querySelector('[data-ww-sticky-kauf]');
    document.addEventListener('rww:wahl', function (e) {
      var n = e.detail.namen || [];
      if (titel) titel.textContent = n.length ? (n.length > 1 ? 'Deine Sets: ' : 'Dein Set: ') + n.join(' + ') : 'Noch kein Set gewählt';
      if (preis) preis.textContent = euro(e.detail.cent || 0);
      if (knopf) {
        knopf.textContent = knopf.getAttribute(n.length > 1 ? 'data-mehr' : 'data-eins');
        knopf.disabled = n.length === 0;
      }
    });
    if (knopf) {
      knopf.addEventListener('click', function () {
        var held = document.querySelector('[data-ww-wahl-kauf]');
        if (held) { held.click(); return; }
        var sets = document.getElementById('sets');
        if (sets) sets.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' });
      });
    }
    var ziel = document.querySelector('.rww-buehne__kauf') || document.querySelector('form[data-type="add-to-cart-form"]');
    var kaufSichtbar = true, formSichtbar = false;
    function update() {
      var zeigen = !kaufSichtbar && !formSichtbar && window.scrollY > 200;
      bar.classList.toggle('rww-sticky--an', zeigen);
      bar.setAttribute('aria-hidden', String(!zeigen));
      bar.toggleAttribute('inert', !zeigen);
    }
    if (hatIO && ziel) {
      new IntersectionObserver(function (e) { kaufSichtbar = e[0].isIntersecting; update(); }, { rootMargin: '-80px 0px 0px 0px' }).observe(ziel);
    } else { kaufSichtbar = false; }
    var kontakt = document.getElementById('ContactForm');
    if (hatIO && kontakt) {
      new IntersectionObserver(function (e) { formSichtbar = e[0].isIntersecting; update(); }).observe(kontakt);
    }
    var wartet = false;
    window.addEventListener('scroll', function () {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(function () { wartet = false; update(); });
    }, { passive: true });
    update();
  }

  /* ---------- Kombi-Feld in der Kaufbox ---------- */

  function kombiFeld(wurzel) {
    var felder = wurzel.querySelectorAll('[data-ww-plus]');
    Array.prototype.forEach.call(felder, function (feld) {
      var optionen = Array.prototype.slice.call(feld.querySelectorAll('[data-ww-opt]'));
      var summe = feld.querySelector('[data-ww-plus-summe]');
      var btn = feld.querySelector('[data-ww-plus-kauf]');
      var status = feld.querySelector('[data-ww-plus-status]');
      var tuchPreis = parseInt(feld.getAttribute('data-tuch-preis'), 10) || 0;
      var tuchId = parseInt(feld.getAttribute('data-tuch-variante'), 10);

      function menge() {
        var section = feld.closest('.shopify-section') || document;
        var input = section.querySelector('.quantity__input');
        var m = input ? parseInt(input.value, 10) : 1;
        return m > 0 ? m : 1;
      }
      function gewaehlt() {
        return optionen.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0] || optionen[0];
      }
      function rechnen() {
        var o = gewaehlt();
        if (!o) return;
        var cent = tuchPreis * menge() + (parseInt(o.getAttribute('data-preis'), 10) || 0);
        if (summe) summe.textContent = euro(cent);
      }
      optionen.forEach(function (o, i) {
        o.addEventListener('click', function () {
          optionen.forEach(function (x) {
            x.setAttribute('aria-checked', x === o ? 'true' : 'false');
            x.tabIndex = x === o ? 0 : -1;
          });
          rechnen();
        });
        o.addEventListener('keydown', function (e) {
          var r = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (!r) return;
          e.preventDefault();
          var n = optionen[(i + r + optionen.length) % optionen.length];
          n.focus();
          n.click();
        });
      });
      var section = feld.closest('.shopify-section');
      if (section) {
        section.addEventListener('change', function (e) { if (e.target.classList.contains('quantity__input')) rechnen(); });
        section.addEventListener('click', function (e) { if (e.target.closest('.quantity__button')) setTimeout(rechnen, 0); });
      }
      if (btn) {
        btn.addEventListener('click', function () {
          var o = gewaehlt();
          if (!o || !tuchId) return;
          if (status) status.textContent = '';
          knopfLaeuft(btn, true);
          inDenWarenkorb([
            { id: tuchId, quantity: menge() },
            { id: parseInt(o.getAttribute('data-variante'), 10), quantity: 1 }
          ]).then(function () {
            knopfLaeuft(btn, false);
          }).catch(function (err) {
            knopfLaeuft(btn, false);
            if (status) status.textContent = 'Das hat nicht geklappt' + (err && err.message ? ': ' + err.message : '') + '.';
          });
        });
      }
      rechnen();
    });
  }

  /* ---------- Start ---------- */

  function start() {
    var wurzel = document.getElementById('MainContent') || document.body;
    einblenden(wurzel);
    schleifen(wurzel);
    zaehlen(wurzel);
    buehne(wurzel);
    wischen(wurzel);
    setBaukasten(wurzel);
    setLeiste();
    buehnenWahl(wurzel);
    kombiFeld(wurzel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
